export const GET_FAQ = "getFaq";